var render = function render(){var _vm=this,_c=_vm._self._c;return _c('CloPlaylist',{attrs:{"list":_vm.list,"title":_vm.title,"moreUrl":_vm.moreUrl,"mediaDownloadUrl":_vm.mediaDownloadUrl}})
}
var staticRenderFns = []

export { render, staticRenderFns }